module.exports = __webpack_public_path__ + "img/banner1.fe8c855d.png";